import { render, staticRenderFns } from "./ImageCategory.vue?vue&type=template&id=f10bbc38&scoped=true"
import script from "./ImageCategory.vue?vue&type=script&lang=js"
export * from "./ImageCategory.vue?vue&type=script&lang=js"
import style0 from "./ImageCategory.vue?vue&type=style&index=0&id=f10bbc38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10bbc38",
  null
  
)

export default component.exports